import type {
    BundleTemplateProcessedModel,
    BundleTemplateProcessedModelItem
} from '~/types';

export function useBundleUtils() {

    function getOutputModel(
        processedModels:  Map<string, BundleTemplateProcessedModelItem[]>
    ): BundleTemplateProcessedModel {
        return Array.from(processedModels.values()).flat();
    }

    return {
        getOutputModel
    };
}
